import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col text-start" }
const _hoisted_3 = { class: "row mb-4" }
const _hoisted_4 = { class: "col-xxl-6 text-start" }
const _hoisted_5 = {
  for: "customRange3",
  class: "form-label"
}
const _hoisted_6 = { class: "fw-bolder" }
const _hoisted_7 = { class: "d-flex justify-content-between guiide-range-slider" }
const _hoisted_8 = { class: "pe-3" }
const _hoisted_9 = ["min", "max"]
const _hoisted_10 = { class: "ps-3" }
const _hoisted_11 = { class: "row mb-3" }
const _hoisted_12 = { class: "col-xxl-6 text-start" }
const _hoisted_13 = {
  for: "customRange3",
  class: "form-label"
}
const _hoisted_14 = { class: "fw-bolder" }
const _hoisted_15 = { class: "d-flex justify-content-between guiide-range-slider" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = {
  key: 0,
  class: "row"
}
const _hoisted_18 = { class: "col text-start" }
const _hoisted_19 = { class: "fw-bold" }
const _hoisted_20 = { class: "row" }
const _hoisted_21 = { class: "col text-start" }
const _hoisted_22 = { class: "col" }
const _hoisted_23 = ["disabled"]
const _hoisted_24 = { class: "container-fluid border border-dark rounded p-3 mb-4" }
const _hoisted_25 = { class: "row" }
const _hoisted_26 = { class: "col-lg-6" }
const _hoisted_27 = { class: "col-lg-6" }
const _hoisted_28 = { class: "row" }
const _hoisted_29 = { class: "col" }
const _hoisted_30 = { class: "row" }
const _hoisted_31 = { class: "col-sm-6" }
const _hoisted_32 = { class: "col-sm-6" }
const _hoisted_33 = { class: "row mb-2" }
const _hoisted_34 = { class: "col-sm-6" }
const _hoisted_35 = { class: "col-sm-6" }
const _hoisted_36 = {
  key: 2,
  class: "row"
}
const _hoisted_37 = { class: "row" }
const _hoisted_38 = { class: "col-6" }
const _hoisted_39 = { class: "col-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AnnuityProvidersList = _resolveComponent("AnnuityProvidersList")!
  const _component_income_chart = _resolveComponent("income-chart")!
  const _component_pots_chart = _resolveComponent("pots-chart")!
  const _component_scenario = _resolveComponent("scenario")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("p", null, [
          _cache[7] || (_cache[7] = _createTextVNode(" Both flexible drawdown income and guaranteed lifetime income (annuities) have a number of great features. You can model both together with us. ")),
          (_ctx.displaySuppliers)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _cache[4] || (_cache[4] = _createTextVNode(" Then if you are looking to buy some guaranteed income now, ")),
                _cache[5] || (_cache[5] = _createElementVNode("strong", null, "you can do so via Hargreaves Lansdown below", -1)),
                _cache[6] || (_cache[6] = _createTextVNode(". Our model uses current market rates. They will ask you further questions on the exact type of annuity you want, where you live, your lifestyle and health to get final rates for you. "))
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _cache[8] || (_cache[8] = _createElementVNode("p", null, [
          _createTextVNode(" Below the income, pots, and scenarios show the outcome of your plan assuming you buy an income with no increases, no spouses benefits and no guarantee for how long it will be paid (lots of other types are available). To change the age at which you want to add this or the percentage of your non protected pot you want to use, move the sliders below and click "),
          _createElementVNode("strong", null, "Update Plan"),
          _createTextVNode(" to see the effect. ")
        ], -1))
      ])
    ]),
    _cache[17] || (_cache[17] = _createElementVNode("div", { class: "row mt-3" }, [
      _createElementVNode("div", { class: "col" }, [
        _createElementVNode("p", { class: "text-start mb-0" })
      ])
    ], -1)),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("label", _hoisted_5, [
          _cache[9] || (_cache[9] = _createTextVNode(" Age to add some guaranteed income from: ")),
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.ageText), 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.minPurchaseAge), 1),
          _withDirectives(_createElementVNode("input", {
            type: "range",
            class: "form-range",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.ageModel) = $event)),
            min: _ctx.minPurchaseAge,
            max: _ctx.maxPurchaseAge,
            step: "1"
          }, null, 8, _hoisted_9), [
            [_vModelText, _ctx.ageModel]
          ]),
          _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.maxPurchaseAge), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("label", _hoisted_13, [
          _cache[10] || (_cache[10] = _createTextVNode(" Percentage of your non protected pension pot used to buy it: ")),
          _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.amountText), 1)
        ]),
        _createElementVNode("div", _hoisted_15, [
          _cache[11] || (_cache[11] = _createElementVNode("div", { class: "pe-3" }, " 0 ", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "range",
            class: "form-range",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.amountModel) = $event)),
            min: "0",
            max: 80,
            step: "5"
          }, null, 512), [
            [_vModelText, _ctx.amountModel]
          ]),
          _cache[12] || (_cache[12] = _createElementVNode("div", { class: "ps-3" }, "80", -1))
        ]),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-primary mt-4",
          disabled: _ctx.inTransaction,
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onUpdateClicked()))
        }, [
          _cache[13] || (_cache[13] = _createTextVNode(" Update Plan ")),
          _createElementVNode("i", {
            class: _normalizeClass(["bi", _ctx.updateButtonIcon])
          }, null, 2)
        ], 8, _hoisted_16)
      ])
    ]),
    (_ctx.isCurrentlySubscribedToGI)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (_ctx.showMinimumPurchaseWarning)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("p", _hoisted_19, " Please note that there is a minimum purchase amount of " + _toDisplayString(_ctx.minPurchaseAmountFormatted) + ". ", 1)
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("p", null, " You have included a guaranteed income purchase in your plan. " + _toDisplayString(_ctx.guaranteedIncomeSubscriptionText), 1),
              _cache[14] || (_cache[14] = _createElementVNode("p", null, [
                _createTextVNode("Click "),
                _createElementVNode("i", null, "Remove"),
                _createTextVNode(" to go back to just using non guaranteed drawdown income.")
              ], -1))
            ])
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["row", { 'mb-4': !_ctx.displaySuppliers}])
          }, [
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary btn-sm float-start",
                disabled: _ctx.inTransaction,
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onUnsubscribeGuaranteedIncomeClicked()))
              }, _cache[15] || (_cache[15] = [
                _createElementVNode("span", { class: "d-none d-sm-inline-block me-2" }, "Remove", -1),
                _createElementVNode("i", { class: "bi bi-dash-circle" }, null, -1)
              ]), 8, _hoisted_23)
            ])
          ], 2)
        ], 64))
      : _createCommentVNode("", true),
    (_ctx.displaySuppliers)
      ? (_openBlock(), _createBlock(_component_AnnuityProvidersList, { key: 1 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_24, [
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("div", _hoisted_26, [
          _createVNode(_component_income_chart)
        ]),
        _createElementVNode("div", _hoisted_27, [
          _createVNode(_component_pots_chart)
        ])
      ]),
      _createElementVNode("div", _hoisted_28, [
        _createElementVNode("div", _hoisted_29, [
          _createVNode(_component_scenario, {
            scenario: _ctx.ScenarioType.AccordingToPlan,
            number: "1",
            showBorder: false
          }, null, 8, ["scenario"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_30, [
      _createElementVNode("div", _hoisted_31, [
        _createVNode(_component_scenario, {
          scenario: _ctx.ScenarioType.LowerGrowth,
          number: "2",
          showGraphButton: false,
          onShowGraphs: _ctx.onShowGraphs
        }, null, 8, ["scenario", "onShowGraphs"])
      ]),
      _createElementVNode("div", _hoisted_32, [
        _createVNode(_component_scenario, {
          scenario: _ctx.ScenarioType.LiveThreeYearsLonger,
          number: "3",
          showGraphButton: false,
          onShowGraphs: _ctx.onShowGraphs
        }, null, 8, ["scenario", "onShowGraphs"])
      ])
    ]),
    _createElementVNode("div", _hoisted_33, [
      _createElementVNode("div", _hoisted_34, [
        _createVNode(_component_scenario, {
          scenario: _ctx.ScenarioType.PotsFallTwentyPercent,
          number: "4",
          showGraphButton: false,
          onShowGraphs: _ctx.onShowGraphs
        }, null, 8, ["scenario", "onShowGraphs"])
      ]),
      _createElementVNode("div", _hoisted_35, [
        _createVNode(_component_scenario, {
          scenario: _ctx.ScenarioType.NeedExtraMoneyForLastTwoYears,
          number: "5",
          showGraphButton: false,
          onShowGraphs: _ctx.onShowGraphs
        }, null, 8, ["scenario", "onShowGraphs"])
      ])
    ]),
    (_ctx.displaySuppliers)
      ? (_openBlock(), _createElementBlock("div", _hoisted_36, _cache[16] || (_cache[16] = [
          _createElementVNode("div", { class: "col text-start" }, [
            _createElementVNode("p", null, [
              _createElementVNode("small", null, " The calculations above are based on illustrative figures. If you want to buy some guaranteed income you will need to get an actual quote. This quote will depend on a number of factors such as interest rates on that day and factors that are specific to you such as the annuity type you want, your age, health, postcode and lifestyle. ")
            ]),
            _createElementVNode("p", null, [
              _createElementVNode("small", null, [
                _createTextVNode(" Disclaimer - We do not take any referral fees from any partners above. Some partners may license our tools for their own use, so we do have commercial relationships. You can purchase an annuity on your own or get independent financial advice to find the most appropriate. You can do this via our Advisers page, or go to "),
                _createElementVNode("a", {
                  href: "https://www.moneyhelper.org.uk",
                  target: "_blank"
                }, "moneyhelper.org.uk"),
                _createTextVNode(" if you want more help on finding an adviser. ")
              ])
            ])
          ], -1)
        ])))
      : _createCommentVNode("", true),
    _createVNode(_component_modal, {
      ref: "graphModal",
      title: _ctx.graphModalTitle,
      idKey: "graphModal",
      key: "graphModal",
      isWide: true
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_37, [
          _createElementVNode("div", _hoisted_38, [
            _createVNode(_component_income_chart)
          ]),
          _createElementVNode("div", _hoisted_39, [
            _createVNode(_component_pots_chart)
          ])
        ])
      ]),
      _: 1
    }, 8, ["title"])
  ], 64))
}